import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsSubagentLimitExceed } from '../../selectors/publishTerms';
import { useIsMobileDevice } from '../../hooks';

import { ActionButtons } from './ActionButtons';

export const ActionButtonsContainer = () => {
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);
  const isMobile = useIsMobileDevice();
  const withPublishBtn = !isMobile || !isSubagentLimitExceed;

  return <ActionButtons withPublishBtn={withPublishBtn} />;
};
